import Reporter from '../reporter';
function Reportable(target, propertyKey, descriptor) {
    // Запоминаем исходную функцию
    let originalMethod = descriptor.value;
    if (originalMethod) {
        // Подменяем ее на нашу обертку
        descriptor.value = function SafeWrapper() {
            try {
                // Вызываем исходный метод
                let result = originalMethod.apply(this, arguments);
                return result;
            }
            catch (ex) {
                let info = {
                    'class': target.constructor.name, //Class name
                    'method': propertyKey, //method name
                    v: 3
                };
                Reporter.reportError(`${info.class}.${info.method}`, { info, arguments: [...arguments] }, ex);
                return ex;
            }
        };
    }
    return descriptor;
}
export default Reportable;
